<template>
	<v-dialog
		v-model="fileOpenerFallback.visible"
		scrollable
		persistent
		max-width="fit-content"
		transition="dialog-transition">
		<v-card color="background">
			<v-card-title class="background darken-1 py-1 pr-0">
				<span class="headline primary--text">
					FileOpener
				</span>
				<v-spacer></v-spacer>
				<v-btn flat icon color="primary" @click="close()">
					<v-icon>close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text class="pb-0 text-xs-center">
				<div class="subheading" v-if="winpath">
					{{ winpath }}
				</div>
				<div class="subheading error--text" v-if="fileOpenerFallback.message">
					{{ fileOpenerFallback.message }}
				</div>
				<v-progress-linear height="5" color="primary" indeterminate v-if="fileOpenerFallback.status === 'loading'" />
				<v-divider v-if="fileOpenerFallback.status !== 'loading'" />
			</v-card-text>
			<v-card-actions class="pt-0" v-if="fileOpenerFallback.status !== 'loading'">
				<router-link :to="{name: 'Filesystem', query: {path: winpath}}" target="_blank">
					<v-btn color="primary color--text" class="text-none mr-5">
						<v-icon class="mr-2">folder</v-icon>
						Explorer
					</v-btn>
				</router-link>
				<v-spacer></v-spacer>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>

export default {
	name: '',
	computed: {
		fileOpenerFallback () {
			return this.$store.getters.fileOpenerFallback
		},
		winpath () {
			try {
				return this.fileOpenerFallback.path.replace(/\//g, '\\')
			} catch (error) {
				return false
			}
		}
	},
	methods: {
		close () {
			this.$store.commit('fileOpenerFallbackChange', {
				visible: false,
				message: null,
				path: null,
				status: null
			})
		}
	}
}
</script>

<style scoped>
	a:hover {
		text-decoration: none !important;
	}
</style>



// WEBPACK FOOTER //
// src/file_opener_fallback.vue